import React, { forwardRef } from 'react';
import LockerIcon from '../assets/locker.svg';
import { UserLocationIndicater } from '../assets/constants/Icons';

const LocationSlider = forwardRef(({
  currentLocation,
  filteredLocations,
  selectedLocation,
  onLocationClick,
  onScrollLeft,
  onScrollRight
}, ref) => {
  return (
    <div className="location-slider-container">
      <div className="slider-header">
        <div className="slider-title">
          {currentLocation ? 'Nearest Lockers' : 'Total Lockers'}
          <span>{filteredLocations.length}</span>
        </div>
        <div className="slider-nav">
          <button 
            className="nav-button" 
            onClick={onScrollLeft}
            aria-label="Scroll left"
          >
            ←
          </button>
          <button 
            className="nav-button" 
            onClick={onScrollRight}
            aria-label="Scroll right"
          >
            →
          </button>
        </div>
      </div>

      <div className="locations-slider" ref={ref}>
        {filteredLocations.map((location) => (
          <div
            key={location.id}
            className={`location-card ${selectedLocation?.id === location.id ? 'selected' : ''}`}
            onClick={() => onLocationClick(location)}
          >
            <div className="card-header">
              <div className="card-icon">
                <img src={LockerIcon} alt={location.name} />
              </div>
              <div className="card-title">
                <h4>{location.name}</h4>
                <p>
                  <span>{location.marathiName || location.city || ''}</span>
                  <span className="distance-badge">
                    {location.distance || '0'} km
                    {currentLocation && parseFloat(location.distance) < 1 && (
                      <UserLocationIndicater />
                    )}
                  </span>
                </p>
              </div>
            </div>

            <div className="card-actions">
              <button className="action-btn navigate-btn">
                Next step
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

LocationSlider.displayName = 'LocationSlider';

export default LocationSlider;